import {
  parseBatchRecipientCsvFile,
  type BatchRecipientFileRow,
} from "../../utils/batch-recipient-file";

export type BatchRecipientRow = BatchRecipientFileRow;

export async function parseBatchRecipientFile(
  file: File,
): Promise<BatchRecipientRow[]> {
  return parseBatchRecipientCsvFile(file);
}
